var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 63,
    viewBox: "0 0 64 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5994 25.4436H23.1016V31.4407H27.5994V49.4319H35.0957V31.4407H40.4931L41.0928 25.4436H35.0957V22.8948C35.0957 21.5455 35.3956 20.9458 36.7449 20.9458H41.0928V13.4495H35.3956C29.9982 13.4495 27.5994 15.8483 27.5994 20.3461V25.4436Z",
    fill: "#F4F1EE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.7e7c67e5d9e58587707968df09494183.svg";
export { ForwardRef as ReactComponent };